var React = require('react');

function SuccessIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41 0C18.3932 0 0 18.3917 0 41C0 63.6083 18.3932 82 41 82C63.6068 82 82 63.6083 82 41C82 18.3917 63.6068 0 41 0ZM63.8575 27.3265L38.6267 55.7111C38.0054 56.4097 37.1397 56.7692 36.2677 56.7692C35.5754 56.7692 34.88 56.5422 34.2981 56.0785L18.5288 43.4632C17.1695 42.3767 16.9488 40.3913 18.0368 39.0304C19.1233 37.6695 21.1103 37.4488 22.4696 38.5368L35.9002 49.2804L59.1425 23.1335C60.2968 21.8309 62.2932 21.7142 63.5942 22.8717C64.8967 24.0307 65.015 26.024 63.8575 27.3265Z","fill":"#22C993"}));
}

SuccessIcon.defaultProps = {"width":"82","height":"82","viewBox":"0 0 82 82","fill":"none"};

module.exports = SuccessIcon;

SuccessIcon.default = SuccessIcon;
